import React__default, { useLayoutEffect, useState, useRef } from 'react';
import cn from 'classnames';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styles from 'ui-components/Foldable.scss';

var _excluded = ["className", "wrapperClass", "open", "children"];
var TRANSITION_TIME = parseInt(styles.timeout, 10);
var MUTATION_OBSERVER_OPT = {
  attributes: true,
  childList: true,
  subtree: true,
  characterData: true
};
var useBrowserLayoutEffect = process.browser ? useLayoutEffect : function () {};

/**
 * A foldable wrapping component
 */
var Foldable = function Foldable(_ref) {
  var _cn;
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    _ref$wrapperClass = _ref.wrapperClass,
    wrapperClass = _ref$wrapperClass === void 0 ? "" : _ref$wrapperClass,
    _ref$open = _ref.open,
    open = _ref$open === void 0 ? false : _ref$open,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _useState = useState(!open),
    overflowHidden = _useState[0],
    setOverflowHidden = _useState[1];
  var _useState2 = useState(false),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var firstUpdate = useRef(true);
  var _open = useRef(open);
  var timeout = useRef(null);
  var element = useRef(null);
  var wrapper = useRef(null);
  var transitionEnd = function transitionEnd(opened) {
    setOverflowHidden(!opened);
    // Add class when foldable is opened
    if (opened) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  };
  useBrowserLayoutEffect(function () {
    _open.current = open;
    var recalcHeight = function recalcHeight() {
      if (!firstUpdate.current) {
        setOverflowHidden(true);
        if (timeout.current) {
          clearTimeout(timeout.current);
        }
        timeout.current = setTimeout(function () {
          return transitionEnd(_open.current);
        }, TRANSITION_TIME);
      }
      if (element.current && wrapper.current) {
        element.current.style.maxHeight = _open.current ? wrapper.current.getBoundingClientRect().height + "px" : "0px";
      }
      if (firstUpdate.current) {
        firstUpdate.current = false;
      }
    };
    recalcHeight();
    if (!_open.current) {
      return;
    }
    var observer;

    // Re-calculate height when the wrappers content size changes
    if (process.browser) {
      if ("ResizeObserver" in window) {
        observer = new ResizeObserver(function () {
          if (_open.current) {
            recalcHeight();
          }
        });
        if (wrapper.current) {
          observer.observe(wrapper.current);
        }
      } else if ("MutationObserver" in window) {
        observer = new MutationObserver(function () {
          if (_open.current) {
            recalcHeight();
          }
        });
        if (wrapper.current) {
          observer.observe(wrapper.current, MUTATION_OBSERVER_OPT);
        }
      }
    }
    return function () {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [open]);
  return /*#__PURE__*/React__default.createElement("div", _extends({}, props, {
    ref: element,
    style: {
      overflow: overflowHidden ? "hidden" : "visible",
      visibility: open ? "visible" : "hidden"
    },
    "data-foldable": "true",
    className: cn((_cn = {}, _cn[styles.block] = true, _cn[styles.isOpen] = isOpen, _cn[wrapperClass] = Boolean(wrapperClass), _cn))
  }), /*#__PURE__*/React__default.createElement("div", {
    ref: wrapper,
    className: className
  }, children));
};

export { Foldable };
//# sourceMappingURL=index.js.map
